// extracted by mini-css-extract-plugin
export default {"container":"ContentWithIcon_container__O3WHb"};